import * as Sentry from '@sentry/browser';
import { notification } from 'antd';
import { HttpError } from 'api/api-client/HttpError';
import i18next from 'i18next';
import { isDev } from 'utils';

const serialize = (e: unknown) => JSON.stringify(e, null, 2);

const logger = {
  log: (error: unknown, breadcrumbs?: Sentry.Breadcrumb[], showNotification = true) => {
    let errorName = i18next.t('errors.generic.title');
    let errorMessage =
      typeof error === 'string' ? error : i18next.t('errors.generic.fallback_message');
    let status: number | undefined = undefined;

    if (
      error == null ||
      (error instanceof TypeError &&
        error.message === 'NetworkError when attempting to fetch resource.')
    ) {
      notification.error({
        title: i18next.t('errors.generic.title'),
        description: i18next.t('errors.network.description'),
        key: 'networkError',
      });
      return;
    }

    if (error instanceof HttpError) {
      status = error.status;
      errorMessage = error.response.message;
      errorName = error.response.name;

      if (errorName === 'Validation Error') {
        errorMessage = error.response.errors.join('\n');
      } else if (error.response.errors.length > 0) {
        errorMessage += '\n' + error.response.errors.join('\n');
      }

      console.debug(serialize(error.json()));
    } else if (error instanceof Error) {
      errorMessage = error.message;
      errorName = error.name;
    }

    if (showNotification)
      switch (status) {
        case 401:
        case 403:
          notification.error({
            title: i18next.t('errors.unauthorized.title'),
            description: i18next.t('errors.unauthorized.description'),
            key: 'unauthorized',
          });
          break;
        case 402:
          notification.error({
            title: i18next.t('errors.payment_required.title'),
            description: i18next.t('errors.payment_required.description'),
            key: 'paymentRequired',
          });
          break;
        case 404:
          notification.error({
            title: i18next.t('errors.not_found.title'),
            description: errorMessage,
            key: 'notFound',
          });
          break;
        case 409:
          notification.error({
            title: i18next.t('errors.conflict.title'),
            description: errorMessage,
            key: 'conflict',
          });
          break;
        default:
          notification.error({
            title: errorName,
            description: errorMessage,
            key: errorName + errorMessage,
          });
          break;
      }

    if (!isDev()) {
      breadcrumbs?.forEach(({ category, message }) =>
        Sentry.addBreadcrumb({
          category,
          message,
          level: 'info',
        }),
      );

      Sentry.captureException(error);
    }
  },
};

export default logger;
